<template>
    <div class="report__page">
        <DataTable :disabled="(activeReportType === 3) ? true : false" @row-select="handleSelectionAdditionSites($event)" @row-unselect="handleSelectionRemovalSites($event)" class="site__table" :globalFilterFields="['site_name']" sortField="site_name" :sortOrder="1" :filters="filters" dataKey="site_name" :paginator="true" :rows="5" :value="sites" ref="sites_table" :selection.sync="selectedSites" :loading="modalLoading">
            <template #header>
                <div class="p-d-md-flex p-jc-md-between">
                    <span class="p-d-md-flex p-ai-center p-jc-md-between" style="gap: 0.75rem;">
                        <small style="margin-right: 2rem;">Select Sites</small>
                        <InputSwitch v-model="allSitesSelected" @change="toggleSelectedSites" />
                        <span>{{ selectAllSitesButtonText }}</span>
                    </span>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Search Sites" />
                    </span>
                </div>
                <div class="site__table--disabled" v-if="activeReportType === 3">
                    <small>Sites are disabled for this report type</small>
                </div>
            </template>
            <template #empty>
                No sites found.
            </template>
            <template #loading>
                Loading sites. Please wait.
            </template>
            <Column selectionMode="multiple" headerClass="table__button--header" bodyClass="table__button"></Column>
            <Column field="name" header="Report Name" headerClass="hide_col">
                <template #body="slotProps">
                    <span>{{ slotProps.data.site_name }}</span>
                </template>
            </Column>
        </DataTable>

        <TabView class="report__tabs" style="padding: 1rem; margin-top: 2rem;" @tab-change="triggerTabChange($event)" :activeIndex.sync="activeReportType">
            <TabPanel header="Asset Type">
                <DataTable @row-select="handleSelectionAdditionAssetTypes($event)" @row-unselect="handleSelectionRemovalAssetTypes($event)" class="site__table" :value="asset_types" ref="asset_types_table" :selection.sync="selectedAssetTypes">
                    <template #header>
                        <div class="p-d-md-flex p-jc-md-between">
                            <span class="p-d-md-flex p-ai-center p-jc-md-between" style="gap: 0.75rem;">
                                <small style="margin-right: 2rem;">Select Type</small>
                                <InputSwitch v-model="allAssetTypesSelected" @change="toggleSelectedAssetTypes" />
                                <span>{{ selectAllAssetTypestext }}</span>
                            </span>
                        </div>
                    </template>
                    <template #empty>
                        No asset types found.
                    </template>
                    <template #loading>
                        Loading asset types. Please wait.
                    </template>
                    <Column selectionMode="multiple" headerClass="table__button--header" bodyClass="table__button"></Column>
                    <Column field="asset_type">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.label }}</span>
                        </template>
                    </Column>
                </DataTable>
            </TabPanel>
            <TabPanel header="Last Maintained / Attended">
                <small style="margin-block: 1rem; display: block; font-weight: 600;">Select Asset Type</small>
                <div class="p-d-flex p-ai-center" style="gap: 0.75rem; margin-block: 1rem;">
                    <div class="p-d-flex p-ai-center" style="gap: 0.25rem;">
                        <label for="asset">Assets</label>
                        <RadioButton id="asset" v-model="maintenanceSelectedAssetType" name="r1" value="Asset" @change="selectMaintenanceAssetType" />
                    </div>
                    <div class="p-d-flex p-ai-center" style="gap: 0.25rem;">
                        <label for="location">Locations</label>
                        <RadioButton id="location" v-model="maintenanceSelectedAssetType" name="r1" value="Location" @change="selectMaintenanceAssetType" />
                    </div>
                </div>
                <RangePicker />
            </TabPanel>
            <TabPanel header="Attendance Log">
                <RangePicker />
            </TabPanel>
            <TabPanel header="Management Activity Log">
                <RangePicker />
            </TabPanel>
            <TabPanel header="Activity Logs">
                <RangePicker />
            </TabPanel>
            <TabPanel header="Fault Report">
                <small style="margin-block: 1rem; display: block; font-weight: 600;">Select Asset Type</small>
                <div class="p-d-flex p-ai-center" style="gap: 0.75rem; margin-block: 1rem;">
                    <div class="p-d-flex p-ai-center" style="gap: 0.25rem;">
                        <label for="asset">Assets</label>
                        <RadioButton id="asset" v-model="maintenanceSelectedAssetType" name="r1" value="Asset" @change="selectMaintenanceAssetType" />
                    </div>
                    <div class="p-d-flex p-ai-center" style="gap: 0.25rem;">
                        <label for="location">Locations</label>
                        <RadioButton id="location" v-model="maintenanceSelectedAssetType" name="r1" value="Location" @change="selectMaintenanceAssetType" />
                    </div>
                </div>
                <DataTable @row-select="handleSelectionAdditionFaultTypes($event)" @row-unselect="handleSelectionRemovalFaultTypes($event)" class="site__table" :value="fault_types" ref="fault_types_table" :selection.sync="selectedFaultTypes">
                    <template #header>
                        <div class="p-d-md-flex p-jc-md-between">
                            <span class="p-d-md-flex p-ai-center p-jc-md-between" style="gap: 0.75rem;">
                                <small style="margin-right: 2rem;">Select Type</small>
                                <InputSwitch v-model="allFaultTypesSelected" @change="toggleSelectedFaultTypes" />
                                <span>{{ selectAllFaultTypesText }}</span>
                            </span>
                        </div>
                    </template>
                    <template #empty>
                        No fault types found.
                    </template>
                    <template #loading>
                        Loading fault types. Please wait.
                    </template>
                    <Column selectionMode="multiple" headerClass="table__button--header" bodyClass="table__button"></Column>
                    <Column field="fault_type">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.label }}</span>
                        </template>
                    </Column>
                </DataTable>
            </TabPanel>
            <TabPanel header="Fault Logs">
                <small style="margin-block: 1rem; display: block; font-weight: 600;">Select Asset Type</small>
                <div class="p-d-flex p-ai-center" style="gap: 0.75rem; margin-block: 1rem;">
                    <div class="p-d-flex p-ai-center" style="gap: 0.25rem;">
                        <label for="asset">Assets</label>
                        <RadioButton id="asset" v-model="maintenanceSelectedAssetType" name="r1" value="Asset" @change="selectMaintenanceAssetType" />
                    </div>
                    <div class="p-d-flex p-ai-center" style="gap: 0.25rem;">
                        <label for="location">Locations</label>
                        <RadioButton id="location" v-model="maintenanceSelectedAssetType" name="r1" value="Location" @change="selectMaintenanceAssetType" />
                    </div>
                </div>
                <RangePicker :allowCustomRange="false" />
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import { db } from '@/firebase.js';
import { FilterMatchMode } from 'primevue/api';
import RangePicker from './RangePicker.vue';

export default {
    components: {
        RangePicker
    },
    data() {
        return {
            filters: { global: { value: null, matchMode: FilterMatchMode.CONTAINS } },
            newCustomReportTitle: '',
            activeReportType: null,
            modalLoading: true,
            asset_types: [
                { asset_type: 'Asset', label: 'Asset' },
                { asset_type: 'Location', label: 'Location' },
                { asset_type: '', label: 'Unassigned' },
            ],
            allAssetTypesSelected: false,
            selectAllAssetTypestext: 'Select All',
            selectedAssetTypes: [],

            sites: [],
            allSitesSelected: false,
            selectAllSitesButtonText: 'Select All',
            selectedSites: [],

            maintenanceSelectedAssetType: 'Asset',

            fault_types: [
                { fault_type: 'active', label: 'Active' },
                { fault_type: 'in_progress', label: 'In Progress' },
                { fault_type: 'rectified', label: 'Rectified' },
            ],
            allFaultTypesSelected: false,
            selectAllFaultTypesText: 'Select All',
            selectedFaultTypes: [],
        }
    },

    async mounted() {
        await this.fetchSites()
        this.selectedSites = [...this.$store.getters['createCustomReport/getSites']]
        this.selectedAssetTypes = [...this.$store.getters['createCustomReport/getAssetTypes']]
        this.selectedFaultTypes = (this.$store.getters['createCustomReport/getReportType'] === 5) ? [...this.$store.getters['createCustomReport/getFaultTypes']] : []
        this.activeReportType = this.$store.getters['createCustomReport/getReportType']
        this.maintenanceSelectedAssetType = this.$store.getters['createCustomReport/getMaintenanceSelectedAssetType']

        this.checkSelectedItems()
    },

    methods: {

        checkSelectedItems() {
            if (this.selectedSites.length == this.sites.length) {
                this.allSitesSelected = true
                this.selectAllSitesButtonText = 'Deselect All'
            }

            if (this.selectedAssetTypes.length == this.asset_types.length) {
                this.allAssetTypesSelected = true
                this.selectAllAssetTypestext = 'Deselect All'
            }

            if (this.selectedFaultTypes.length == this.fault_types.length) {
                this.allFaultTypesSelected = true
                this.selectAllFaultTypesText = 'Deselect All'
            }
        },

        triggerTabChange(e) {
            const tabIndex = e.index;
            this.$store.dispatch('createCustomReport/selectReportType', tabIndex)
            // when report type changes, ensure details are cleared to prevent overlap, site_id selected by default
            this.$store.dispatch('createCustomReport/selectReportDetails', [])
        },

        async fetchSites() {
            if (!this.sites.length) {
                this.modalLoading = true
                const siteSnapshot = await db.collection('sites')
                    .where('client_id', '==', this.$route.params.client_id)
                    .get()

                this.sites = siteSnapshot.docs.map(site => ({
                    site_name: site.data().name,
                    site_id: site.id
                }))

                this.modalLoading = false
            }
        },

        toggleSelectedSites() {
            if (this.allSitesSelected) {
                // Select all sites and add them to Vuex store
                this.selectedSites = [...this.sites]; // Local state (table selection)
                this.sites.forEach(site => {
                    if (!this.$store.getters['createCustomReport/getSites'].some(s => s.site_id === site.site_id)) {
                        this.$store.dispatch('createCustomReport/addSite', site); // Add to Vuex
                    }
                });
                this.selectAllSitesButtonText = 'Deselect All';
            } else {
                // Deselect all sites and remove them from Vuex store
                this.selectedSites = [];
                this.sites.forEach(site => {
                    this.$store.dispatch('createCustomReport/removeSite', site); // Remove from Vuex
                });
                this.selectAllSitesButtonText = 'Select All';
            }
        },

        // handlers for sites 
        //////////////////////////////////////////////////////

        handleSelectionAdditionSites(event) {
            const site = event.data;

            // Add newly selected
            if (!this.$store.getters['createCustomReport/getSites'].some(s => s.site_id === site.site_id)) {
                this.$store.dispatch('createCustomReport/addSite', site);
            }

            this.$store.dispatch('createCustomReport/selectFilterOptions', {})
        },
        handleSelectionRemovalSites() {
            // Remove unselected item
            this.$store.getters['createCustomReport/getSites'].forEach(storeSite => {
                // Check if the site was deselected by ensuring it's not in the new selection
                if (!this.selectedSites.some(s => s.site_id === storeSite.site_id)) {
                    this.$store.dispatch('createCustomReport/removeSite', storeSite);
                }
            });
        },

        // handlers for asset types 
        //////////////////////////////////////////////////////

        toggleSelectedAssetTypes() {
            if (this.allAssetTypesSelected) {
                // Select all sites and add them to Vuex store
                this.selectedAssetTypes = [...this.asset_types]; // Local state (table selection)
                this.asset_types.forEach(assetType => {
                    if (!this.$store.getters['createCustomReport/getAssetTypes'].some(s => s.asset_type === assetType.asset_type)) {
                        this.$store.dispatch('createCustomReport/addAssetType', assetType); // Add to Vuex
                    }
                });
                this.selectAllAssetTypestext = 'Deselect All';
            } else {
                // Deselect all sites and remove them from Vuex store
                this.selectedAssetTypes = [];
                this.asset_types.forEach(assetType => {
                    this.$store.dispatch('createCustomReport/removeAssetType', assetType); // Remove from Vuex
                });
                this.selectAllAssetTypestext = 'Select All';
            }
        },

        handleSelectionAdditionAssetTypes(event) {
            const assetType = event.data;

            // Add newly selected
            if (!this.$store.getters['createCustomReport/getAssetTypes'].some(s => s.asset_type === assetType.asset_type)) {
                this.$store.dispatch('createCustomReport/addAssetType', assetType);
            }
        },
        handleSelectionRemovalAssetTypes() {
            // Remove unselected item
            this.$store.getters['createCustomReport/getAssetTypes'].forEach(storeAssetType => {
                // Check if the site was deselected by ensuring it's not in the new selection
                if (!this.selectedAssetTypes.some(s => s.asset_type === storeAssetType.asset_type)) {
                    this.$store.dispatch('createCustomReport/removeAssetType', storeAssetType);
                }
            });
        },

        selectMaintenanceAssetType() {
            this.$store.dispatch('createCustomReport/selectMaintenanceAssetType', this.maintenanceSelectedAssetType)
        },

        // handlers for fault types 
        //////////////////////////////////////////////////////

        toggleSelectedFaultTypes() {
            if (this.allFaultTypesSelected) {
                // Select all fault types and add them to Vuex store
                this.selectedFaultTypes = [...this.fault_types]; // Local state (table selection)
                this.fault_types.forEach(faultType => {
                    if (!this.$store.getters['createCustomReport/getFaultTypes'].some(s => s.fault_type === faultType.fault_type)) {
                        this.$store.dispatch('createCustomReport/addFaultType', faultType); // Add to Vuex
                    }
                });
                this.selectAllFaultTypesText = 'Deselect All';
            } else {
                // Deselect all fault types and remove them from Vuex store
                this.selectedFaultTypes = [];
                this.fault_types.forEach(faultType => {
                    this.$store.dispatch('createCustomReport/removeFaultType', faultType); // Remove from Vuex
                });
                this.selectAllFaultTypesText = 'Select All';
            }
        },

        handleSelectionAdditionFaultTypes(event) {
            const faultType = event.data;

            // Add newly selected
            if (!this.$store.getters['createCustomReport/getFaultTypes'].some(s => s.fault_type === faultType.fault_type)) {
                this.$store.dispatch('createCustomReport/addFaultType', faultType);
            }
        },

        handleSelectionRemovalFaultTypes() {
            // Remove unselected item
            this.$store.getters['createCustomReport/getFaultTypes'].forEach(storeFaultType => {
                // Check if the fault type was deselected by ensuring it's not in the new selection
                if (!this.selectedFaultTypes.some(s => s.fault_type === storeFaultType.fault_type)) {
                    this.$store.dispatch('createCustomReport/removeFaultType', storeFaultType);
                }
            });
        },
    },
    watch: {
        maintenanceSelectedAssetType() {
            // Clear selected report details when maintenance asset type changes
            this.$store.dispatch('createCustomReport/selectReportDetails', [])
        },
        activeReportType() {
            const filterLessReportTypes = [1, 2, 3, 4]
            if (this.activeReportType === 3) {
                this.selectedSites = []
                this.$store.dispatch('createCustomReport/setSites', [])
            }

            if (filterLessReportTypes.includes(this.activeReportType)) {
                this.$store.dispatch('createCustomReport/selectFilterOptions', [])
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.report__detail--label {
    font-size: 1.25rem;
    font-weight: 600;
}

.custom__range--wrapper {
    margin-block: 1rem;
}

.p-datatable[disabled] {
    opacity: 0.5;
    pointer-events: none;
}

.site__table--disabled {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.025);
    backdrop-filter: blur(1px);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;

    span {
        z-index: 1001;
        font-size: 2rem;
        font-weight: 600;
    }
}
</style>
